import { useEffect, useState } from "react";
import DataTableLayerCustom from "../../components/DataTableLayerCustom";
import {PostByAggWithAuth} from "../../utils/axios";
import LottieLoading from "../../components/child/LottieLoading";
import ModalAlert from "../../components/ModalAlert";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

const ListReport = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(null);
    const [listSongs, setListSongs] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0,
    });
    const [filterDate, setFilterDate] = useState(null)

    const columns = [
        {
            header: "Artist",
            accessorKey: "artist_name",
        },
        {
            header: "Title",
            accessorKey: "song_name",
        },
        {
            header: "Streams",
            accessorKey: "streams",
        },
        {
            header: "Listeners",
            accessorKey: "listeners",
        },
	{
	    header: "ISRC",
            accessorKey: "isrc",
        },
    ];

    const getAllSongs = () => {
        setIsLoading(true);
        const url = 'looker/v1/report/find-by-report-date';

            // 💡 Convert "Wed Sep 02 2026..." to "2026-09-02" safely regarding timezones
        const offset = filterDate.getTimezoneOffset();
        const localDate = new Date(filterDate.getTime() - (offset * 60 * 1000));
        const filterDateToStr = localDate.toISOString().split("T")[0];

        PostByAggWithAuth({
            url: url,
            body: {
                "page": pagination.pageIndex + 1,
                "page_size": 500, // Fetching a large batch as per Catalogue pattern
                "report_date": filterDateToStr,
            },
            onResponse: (response) => {
                setIsLoading(false);
                if (response.data.code === "2002000") {
                    const data = response.data.data;
                    setListSongs(data.data || []);
                    setPagination((prev) => ({
                        ...prev,
                        totalRecords: data.total_records,
                        totalPages: data.total_pages,
                    }));
                } else {
                    setListSongs([]);
                }
            },
            onError: (error) => {
                setIsLoading(false);
                console.error("Error Fetching All Songs: ", error);
                setModalOpen(
                    <ModalAlert
                        show={true}
                        type={"failed"}
                        text={error.response?.data?.message?.en || "Failed to fetch songs"}
                        action={() => setModalOpen(null)}
                    />
                );
            }
        });
    };

    const handleFilterDateChanges = () => {

    }

    useEffect(() => {
        if (filterDate == null) return;
        getAllSongs();
    }, [filterDate]);


    const customFilterComponent = () => (
         <div>
            <DatePicker
                id="paymentDate"
                className="form-control text-md"
                selected={filterDate}
                onChange={(date) => setFilterDate(date)}
                dateFormat="yyyy-MM-dd" // 👈 Sets the input visual format
                style={{ fontSize: "20px" }}
                placeholderText="Filter Date"
                maxDate={new Date()} 
            />
        </div>
    )

    return (
        <div>
           
            <DataTableLayerCustom
                data={listSongs}
                columns={columns}
                title={"Looker Report"}
                pagination={pagination}
                showButton={false}
                customFilterContent={customFilterComponent()}
            />
            {isLoading && <LottieLoading text="Loading..." />}
            {modalOpen}
        </div>
    );
};

export default ListReport;
